import React from 'react';
import { Card } from 'react-bootstrap';
import {
  FaBolt,
  FaExclamationTriangle,
  FaInfoCircle,
} from 'react-icons/fa';
import AISparkleIcon from './AISparkleIcon';
import { useTranslation } from 'react-i18next';

const ICON_MAP = {
  success: <FaBolt size={16} style={{ color: '#22C55E' }} />,
  info: <FaInfoCircle size={16} style={{ color: '#3B82F6' }} />,
  warning: <FaExclamationTriangle size={16} style={{ color: '#F59E0B' }} />,
};

const BORDER_MAP = {
  success: '#22C55E',
  info: '#3B82F6',
  warning: '#F59E0B',
};

const AIInsights = ({ insights = [] }) => {
  const { t } = useTranslation();
  if (!insights.length) return null;

  return (
    <Card
      className="mt-4"
      style={{
        backgroundColor: '#F5F9FF',
        borderRadius: 12,
        border: '1px solid #E0ECFF',
      }}
    >
      <Card.Body>
        <div className="font-weight-bold mb-4 d-flex align-items-center">
          <AISparkleIcon size={18} color="#2563EB" className="mr-2" />
          {t('AI Insights & Recommendations')}
        </div>

        {insights.map((item, idx) => (
          <div
            key={idx}
            className="p-3 mb-3 d-flex align-items-start"
            style={{
              border: `1px solid ${BORDER_MAP[item.type]}`,
              borderRadius: 8,
              backgroundColor: '#FFFFFF',
            }}
          >
            <div className="mr-3 mt-1">
              {ICON_MAP[item.type]}
            </div>

            <div>
              <div className="font-weight-bold mb-1">
                {item.title}
              </div>
              <div className="small text-muted">
                {item.message}
              </div>
            </div>
          </div>
        ))}
      </Card.Body>
    </Card>
  );
};

export default AIInsights;
